export default __webpack_public_path__ + "2ac88a9b3ca29268966086c749b2dba7.svg";